<template>
  <div class="teaching-schedule-query-teacher-arrange-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="arranges">
      <DataGrid size="mini"
                border="full"
                height="auto"
                highlight-hover-column
                highlight-current-column
                show-overflow="title"
                show-header-overflow="title"
                resizable
                :data="arranges"
                :sort-config="{sortMethod: dataSortMethod}"
                :span-method="rowMergeMethod">
        <DataGridColumn title="教学点"
                        field="site"
                        :filters="filterSites"
                        :filter-method="dataFilterMethod"
                        width="120"
                        align="center"
                        auto-merge="force"></DataGridColumn>
        <DataGridColumn title="课程名称"
                        field="course"
                        :filters="filterCourses"
                        :filter-method="dataFilterMethod"
                        width="160"
                        auto-merge="force">
        </DataGridColumn>
        <DataGridColumn title="班级"
                        field="clazz"
                        :filters="filterClasses"
                        :filter-method="dataFilterMethod"
                        width="100"
                        auto-merge>
        </DataGridColumn>
        <DataGridColumn title="上课人数"
                        field="lessonCount"
                        sortable
                        width="120"
                        align="center"
                        auto-merge>
          <template #default="{row, column}">
            <LessonCount inline
                         :lesson-count="row[column.property]"
                         :supply-count="row.supplyCount">
            </LessonCount>
          </template>
        </DataGridColumn>
        <DataGridColumn title="上课日期"
                        field="lessonDate"
                        sortable
                        width="100"
                        align="center">
        </DataGridColumn>
        <DataGridColumn title="上课时段"
                        field="lessonPeriod"
                        width="120">
        </DataGridColumn>
        <DataGridColumn title="授课地点"
                        width="160"
                        field="lessonPlace">
        </DataGridColumn>
        <DataGridColumn title="课程类别"
                        field="courseType"
                        sortable
                        width="100"
                        align="center"></DataGridColumn>
        <DataGridColumn title="备注"
                        field="remark"
                        min-width="200">
        </DataGridColumn>
      </DataGrid>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>课表数据加载失败</div>
        <el-button type="text"
                   @click="loadArranges">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import LessonCount from '../../../../../../../../widgets/biz/teaching/LessonCount'
import Hint from '../../../../../../../../elements/Hint'
import objectUtils from '../../../../../../../../../util/objectUtils'
import { getValueByPath } from 'element-ui/lib/utils/util'
export default {
  name: 'TeachingScheduleQueryTeacherArrangeMain',
  components: {
    DataGrid,
    DataGridColumn,
    LessonCount,
    Hint
  },
  props: {
    teacherId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      arranges: null
    }
  },
  computed: {
    filterSites () {
      if (this.arranges) {
        let sites = []
        this.arranges.forEach(arrange => {
          const site = arrange.site
          if (site && !sites.includes(site)) {
            sites.push(site)
          }
        })
        return sites.map(s => {
          return {
            label: s,
            value: s
          }
        })
      }
    },
    filterCourses () {
      if (this.arranges) {
        let courses = []
        this.arranges.forEach(arrange => {
          const course = arrange.course
          if (course && !courses.includes(course)) {
            courses.push(course)
          }
        })
        return courses.map(c => {
          return {
            label: c,
            value: c
          }
        })
      }
    },
    filterClasses () {
      if (this.arranges) {
        let classes = []
        this.arranges.forEach(arrange => {
          const clazz = arrange.clazz
          if (clazz && !classes.includes(clazz)) {
            classes.push(clazz)
          }
        })
        return classes.map(c => {
          return {
            label: c,
            value: c
          }
        })
      }
    }
  },
  methods: {
    loadArranges () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/query/teacher/arranges',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.teacherId
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.arranges = response.data['arranges'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    rowMergeMethod ({row, $rowIndex, column, data}) {
      const autoMerge = column.own && column.own.$attrs.hasOwnProperty('auto-merge')
      if (autoMerge) {
        const property = column.property
        if (property) {
          const cellValue = getValueByPath(row, property)
          const prevRow = data[$rowIndex - 1]
          const forceMerge = column.own.$attrs['auto-merge'] === 'force'
          if (prevRow && (row.scheduleId === prevRow.scheduleId || (forceMerge && row.site === prevRow.site && objectUtils.hasValue(cellValue) && getValueByPath(prevRow, property) === cellValue))) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let nextRow = data[$rowIndex + 1]
            let countRowspan = 1
            while (nextRow) {
              if (row.scheduleId === nextRow.scheduleId || (forceMerge && row.site === nextRow.site && objectUtils.hasValue(cellValue) && getValueByPath(nextRow, property) === cellValue)) {
                nextRow = data[++countRowspan + $rowIndex]
              } else {
                break
              }
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      }
    },
    dataFilterMethod ({value, row, column}) {
      if (column && column.property) {
        return getValueByPath(row, column.property) === value
      }
    },
    dataSortMethod ({column, data, order}) {
      let result = data
      if (column.property) {
        if (order) {
          result = data.sort((d1, d2) => {
            // 同一组才可以排序
            if (d1.scheduleId === d2.scheduleId) {
              let v1 = getValueByPath(d1, column.property)
              let v2 = getValueByPath(d2, column.property)
              if (objectUtils.hasValue(v1)) {
                if (objectUtils.hasValue(v2)) {
                  return v1 > v2 ? 1 : -1
                } else {
                  return 1
                }
              } else {
                return -1
              }
            } else {
              return -1
            }
          })
          if (order === 'desc') {
            result.reverse()
          }
        }
      }
      return result
    }
  },
  mounted () {
    this.loadArranges()
  },
  activated () {
    if (this.visible) {
      this.loadArranges()
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadArranges()
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-schedule-query-teacher-arrange-main {
    height: 100%;
    .vxe-table {
      height: 100%!important;
      border: none!important;
      &:before {
        display: none;
      }
      .vxe-header--column {
        &.is--filter {
          .vxe-cell {
            .vxe-cell--filter {
              padding-left: 5px;
              i {
                font-size: 12px!important;
              }
            }
          }
        }
      }
      .vxe-table--border-line {
        display: none;
      }
      .vxe-table--loading {
        background-color: rgba(255,255,255,.5);
      }
      .vxe-table--filter-wrapper {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        box-shadow: 0 6px 6px rgba(0,0,0,.1);
        .vxe-table--filter-footer {
          border-top-color: #ebeef5;
        }
      }
    }
  }
</style>
